<div class="d-flex align-items-center">
    <button [outsideClick]="true" [popover]="alertsPopover" [adaptivePosition]="false" style="height: 30px; line-height: 30px;width: 30px;"
        class="btn  text-white bg-primary font-size-lg p-0 d-inline-block shadow-none border-0 text-center d-44 mr-2 rounded position-relative btn-transition-none"
        containerClass="popover-custom-wrapper popover-custom-md" placement="bottom" type="button">
        <!-- <span class="badge badge-position badge-position--top-left badge-circle badge-success">New notifications</span> -->
        <fa-icon [icon]="['far', 'bell']"></fa-icon>
        <span  style="left: -9px;
        top: -9px;
        border-radius: 100%;" class="badge badge-position badge-position--top-center  badge-warning"><b>{{ notifications}}</b></span>
    </button>

    <!-- <button type="button" class="btn btn-primary m-3 badge-wrapper">
        <span class="badge badge-position badge-position--top-left badge-circle badge-success">New notifications</span>
        <fa-icon [icon]="['far', 'bell']"></fa-icon>
        <span class="badge badge-success ml-3"><b>{{notifications}}</b></span>
    </button> -->
</div>
<ng-template #alertsPopover>
    <div class="bg-composed-wrapper bg-midnight-bloom mx-3 mt-3 mb-3 border-0 text-center rounded-sm">
        <div class="bg-composed-img-3 bg-composed-wrapper--image"></div>
        <div class="bg-composed-wrapper--content text-light px-2 py-4">
            <h6 class="font-size-xl font-weight-bold mb-2">Notifications</h6>
            <p class="opacity-8 mb-0">
                    You have <b class="text-success">{{ notifications}}</b>
                    Greet request(s)
            
            </p>
        </div>
    </div>
</ng-template>